<style lang="scss" scoped>
    .VuePagination__pagination {
        @media (max-width: 576px) {
            width: 100%;
            text-align: center;
        }
    }

    .pagination>li>a,
    .pagination>li>span {
        @media (max-width: 767px) {
            float: none;
        }
    }

    .pagination,
    .VuePagination__count {
        margin: 0 0 36px 0;
    }

    .VuePagination__count {
        @media (max-width: 767px) {
            width: 100%;
        }
    }

    .results-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    @media (min-width: 992px) {
        .results-wrapper {
            right: 54px;
        }

        .page-results-paragraph {
            margin-bottom: 0;
            margin-right: 10px;
        }
    }

    @media (max-width: 768px) {
        .VuePagination nav {
            margin-left: 0 !important;
        }
    }

    .results-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-top: -30px;
        left: 289px;
        max-width: 270px;

        @media (max-width: 767px) {
            left: 0;
            margin: 0 0 36px 0;
        }
    }

    .page-results-paragraph {
        margin: 0 10px 0 0;
    }

    .custom-select {
        padding: 5px 25px 5px 8px;
        color: #387EB9;
        margin-top: -7px;
        border: 1px solid #DDD;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        -webkit-appearance: none;
        background: url('/.resources/ampleon-theme/img/asc.gif') center right no-repeat;
        width: 54px;
        height: 34px;
        background-size: 25px;

        &::-ms-expand {
            display: none;
        }
    }

    .VuePagination .nav-paginator {
        margin-left: 0 !important;
    }

    .pagination,
    .VuePagination__count {
        margin: 0 0 36px 0;
    }

    .show-results .pagination.VuePagination__pagination {
        display: none !important;
    }

    .browser-default.custom-select {
        width: 60px;
    }
</style>

<template>
    <div class="paginator">
        <div class="row show-results">
            <div class="col-md-12 col-sm-12 pagination-wrapper">
                <pagination
                        :for="paginatorId"
                        :options="options"
                        :records="results"
                        :page="page"
                        :per-page="parseInt(pageSize)"
                        @paginate="paginate"
                ></pagination>
            </div>

            <div class="col-md-12 col-sm-12 results-wrapper">
                <p class="page-results-paragraph">Results per page</p>
                <select v-model="pageSize" @change="handlePageSize" class="browser-default custom-select">
                    <option v-model="pageSize" v-for="size in pageSizes" :value="size">{{size}}</option>
                </select>
            </div>
        </div>

    </div>
</template>

<script>
    import Pagination from 'vue-pagination-2';

    export default {
        name: "Paginator",
        components: {
            Pagination
        },
        props: {
            paginatorId: {
                type: String,
                default: ""
            },
            results: {
                type: Number,
                default: 0
            },
            page: {
                type: Number,
                default: 1
            },
            pageSizes: {
                type: Array,
                default: [5, 10, 20]
            },
            paginate: {
                type: Function
            },
        },
        data() {
            return {
                pageSize: this.pageSizes[0],
                options: {
                    chunk: 4,
                    texts: {
                        count: 'Showing results {from} to {to} of {count}|{count} results|One result'
                    }
                }
            };
        },
        computed: {
            isSinglePage() {
                return this.results <= this.pageSize;
            },
        },
        methods: {
            handlePageSize() {
                this.$emit('pageSizeChange', this.pageSize);
            }
        }
    };
</script>
